import { AssetOrderLine } from './asset-order-line';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';


export class AssetOrder extends BaseEntity {

  assetOrderCode  : string;
  partner         : Partner = new Partner();
  theDate         : Date;

  assetOrderLines :  AssetOrderLine[];

  constructor() {
    super();

  }
}